import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Portal: FC<PropsWithChildren<{}>> = ({ children }) => {
    const [container] = useState(() => document.createElement('div'));

    useEffect(() => {
        const appContainer = document.getElementById('snakesApp2024');
        appContainer?.appendChild(container);

        return () => {
            appContainer?.removeChild(container);
        };
    }, []);

    return createPortal(children, container);
};
